---
title: Configurare email și căsuță poștală
parent: Documentație
parentHref: /docs
---

# Configurarea căsuței dumneavoastră de email

Planul dumneavoastră TOBY include o adresă de email profesională care se potrivește cu domeniul dumneavoastră (de exemplu, info@domeniul-dvs.de) cu o **căsuță poștală de 15 GB (Maxi-Postfach)**, plus adrese de redirecționare email nelimitate. Aveți nevoie de mai multe căsuțe poștale sau spațiu suplimentar de stocare? Puteți adăuga oricând o altă căsuță poștală de 15 GB — consultați [lista de prețuri](/ro/pricing).

## 1. Creați căsuța dumneavoastră poștală în TOBY

1. Deschideți **Setări → Email** în TOBY.
2. Alegeți adresa pe care o doriți (cum ar fi info@, hello@ sau contact@) și creați căsuța poștală.
3. **Copiați parola:** TOBY afișează parola generată pentru căsuța poștală o singură dată imediat după creare. Copiați-o sau salvați-o înainte de a închide fereastra. (Dacă o pierdeți vreodată, puteți genera o parolă nouă cu un singur clic din **Setări → Email** — emailurile dumneavoastră existente rămân în siguranță.)

## 2. Citiți și trimiteți email în browser (Webmail)

Puteți deschide căsuța de primire de pe orice computer sau browser de telefon fără să instalați o aplicație:

- **Adresa Webmail:** [mail.tobysite.com/SOGo](https://mail.tobysite.com/SOGo)
- **Nume utilizator:** adresa dumneavoastră completă de email (de exemplu, info@domeniul-dvs.de)
- **Parolă:** parola căsuței poștale din **Setări → Email**

## 3. Conectați telefonul sau computerul dumneavoastră (IMAP & SMTP)

Pentru a citi și trimite emailuri în **Apple Mail (iPhone, iPad, Mac)**, **Gmail / Android Mail**, **Outlook** sau **Thunderbird**, adăugați un cont nou **IMAP** în aplicația dumneavoastră de email și introduceți aceste setări de server:

| Setare | Valoare |
| --- | --- |
| **Tip cont** | IMAP |
| **Adresă email / Nume utilizator** | Adresa dumneavoastră completă de email (de exemplu, info@domeniul-dvs.de) |
| **Parolă** | Parola căsuței poștale din Setări → Email |
| **Server email de primire (IMAP)** | mail.tobysite.com |
| **Port de primire** | 993 (SSL/TLS) |
| **Server email de trimitere (SMTP)** | mail.tobysite.com |
| **Port de trimitere** | 465 (SSL/TLS) sau 587 (STARTTLS) |

> **Important:** Asigurați-vă că introduceți **adresa dumneavoastră completă de email** (inclusiv @domeniul-dvs.de) ca nume de utilizator pentru **ambele** servere de primire (IMAP) și trimitere (SMTP).

### Pas cu pas pe iPhone & iPad (iOS Mail)

1. Deschideți aplicația **Setări** pe iPhone → **Aplicații** → **Mail** → **Conturi Mail** → **Adăugați cont** → **Altul** → **Adăugați cont de email**.
2. Introduceți numele dumneavoastră, adresa completă de email, parola căsuței poștale și o scurtă descriere. Atingeți **Următorul**.
3. Păstrați **IMAP** selectat în partea de sus.
4. Sub **Server email de primire** și **Server email de trimitere**, introduceți mail.tobysite.com ca Nume gazdă, adresa dumneavoastră completă de email ca Nume utilizator și parola căsuței poștale.
5. Atingeți **Următorul** și apoi **Salvați**.

### Pas cu pas pe Android (aplicația Gmail)

1. Deschideți aplicația **Gmail**, atingeți imaginea de profil în colțul din dreapta sus → **Adăugați un alt cont** → **Altul**.
2. Introduceți adresa dumneavoastră completă de email și atingeți **Configurare manuală** → **Personal (IMAP)**, apoi introduceți parola.
3. Pentru **Serverul de primire**, setați serverul la mail.tobysite.com, portul 993 și tipul de securitate SSL/TLS.
4. Pentru **Serverul SMTP de trimitere**, setați serverul la mail.tobysite.com, portul 465 (SSL/TLS) și asigurați-vă că **Se solicită autentificare** este activat cu adresa dumneavoastră completă de email.
5. Atingeți **Următorul** pentru a finaliza.

Următorul: [Newsletter & anunțuri](/ro/docs/newsletter).
